export enum RouteName {
  appCatalog = 'marketplace-app-catalog',
}
